import React from "react";
import { Col, Row } from "react-bootstrap";
import Html from "../../Assets/TechIcons/html5.svg";
import CSS from "../../Assets/TechIcons/css.svg";
import Javascript from "../../Assets/TechIcons/Javascript.svg";
import Node from "../../Assets/TechIcons/Node.svg";
import ReactIcon from "../../Assets/TechIcons/React.svg";
import Python from "../../Assets/TechIcons/Python.svg";
import Typescript from "../../Assets/TechIcons/Typescript.svg";
import Git from "../../Assets/TechIcons/Git.svg";
import Expo from "../../Assets/TechIcons/expo.svg";
import Firebase from "../../Assets/TechIcons/Firebase.svg";
import Docker from "../../Assets/TechIcons/Docker.svg";
import SQL from "../../Assets/TechIcons/SQL.svg";
import Redux from "../../Assets/TechIcons/Redux.svg";
import Tailwind from "../../Assets/TechIcons/Tailwind.svg";
import MUI from "../../Assets/TechIcons/MUI.svg";
import Mapbox from "../../Assets/TechIcons/Mapbox.svg";
import C_Sharp from "../../Assets/TechIcons/C sharp.svg";
import Android from "../../Assets/TechIcons/Android.svg";
import Windows from "../../Assets/TechIcons/Windows.svg";
import IOS from "../../Assets/TechIcons/IOS.svg";
// import MacOS from "../../Assets/TechIcons/MacOS.svg";
import chrome from "../../Assets/TechIcons/Google Chrome.svg";
import vsCode from "../../Assets/TechIcons/vscode.svg";
import AfterEffects from "../../Assets/TechIcons/After Effects.svg";
import Illustrator from "../../Assets/TechIcons/Illustrator.svg";
import Photoshop from "../../Assets/TechIcons/Photoshop.svg";
import Blender from "../../Assets/TechIcons/Blender.svg";
import Esri from "../../Assets/TechIcons/Esri.svg";
import QGIS from "../../Assets/TechIcons/QGIS.svg";




function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Html} alt="Html" className="tech-icon-images" />
        <div className="tech-icons-text">HTML</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={CSS} alt="CSS" className="tech-icon-images" />
        <div className="tech-icons-text">CSS</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Javascript} alt="javascript" className="tech-icon-images" />
        <div className="tech-icons-text">Javascript</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Typescript} alt="typescript" className="tech-icon-images" />
        <div className="tech-icons-text">Typescript</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Node} alt="node" className="tech-icon-images" />
        <div className="tech-icons-text">Node.js</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={ReactIcon} alt="react" className="tech-icon-images" />
        <div className="tech-icons-text">React</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Expo} alt="Expo" className="tech-icon-images" />
        <div className="tech-icons-text">Expo</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Redux} alt="redux" className="tech-icon-images" />
        <div className="tech-icons-text">Redux</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Firebase} alt="firebase" className="tech-icon-images" />
        <div className="tech-icons-text">Firebase</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Git} alt="git" className="tech-icon-images" />
        <div className="tech-icons-text">Git</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Docker} alt="docker" className="tech-icon-images" />
        <div className="tech-icons-text">Docker</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={SQL} alt="SQL" className="tech-icon-images" />
        <div className="tech-icons-text">Postgresql</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Python} alt="Python" className="tech-icon-images" />
        <div className="tech-icons-text">Python</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Tailwind} alt="tailwind" className="tech-icon-images" />
        <div className="tech-icons-text">Tailwind CSS</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={MUI} alt="mui" className="tech-icon-images" />
        <div className="tech-icons-text">Material UI</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={C_Sharp} alt="C#" className="tech-icon-images" />
        <div className="tech-icons-text">C#</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Android} alt="Android" className="tech-icon-images" />
        <div className="tech-icons-text">Android</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Windows} alt="Windows" className="tech-icon-images" />
        <div className="tech-icons-text">Windows</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={IOS} alt="iOS" className="tech-icon-images" />
        <div className="tech-icons-text">iOS</div>
      </Col>

      {/* <Col xs={4} md={2} className="tech-icons">
        <img src={MacOS} alt="macOS" className="tech-icon-images" />
        <div className="tech-icons-text">macOS</div>
      </Col> */}

      <Col xs={4} md={2} className="tech-icons">
        <img src={vsCode} alt="vsCode" className="tech-icon-images" />
        <div className="tech-icons-text">VS Code</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={chrome} alt="Chrome" className="tech-icon-images" />
        <div className="tech-icons-text">Google Chrome</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={AfterEffects} alt="After Effects" className="tech-icon-images" />
        <div className="tech-icons-text">After Effects</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Illustrator} alt="Illustrator" className="tech-icon-images" />
        <div className="tech-icons-text">Illustrator</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Photoshop} alt="Photoshop" className="tech-icon-images" />
        <div className="tech-icons-text">Photoshop</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Blender} alt="Blender" className="tech-icon-images" />
        <div className="tech-icons-text">Blender</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Esri} alt="ArcGIS" className="tech-icon-images" />
        <div className="tech-icons-text">ArcGIS</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Mapbox} alt="Mapbox" className="tech-icon-images" />
        <div className="tech-icons-text">Mapbox</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <img src={QGIS} alt="QGIS" className="tech-icon-images" />
        <div className="tech-icons-text">QGIS</div>
      </Col>

    </Row>
  );
}

export default Techstack;
